import React from 'react';
import { environmentName } from 'config';
import { FormInputSelect } from 'components/form';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { FinanceProgramFormValues } from '../../../types';
import { setProgramDeps } from '../../../lib';
import { deskingSelectors } from '../../../model';
import { PAYLINK_DEV_ACCOUNT_ID, PAYLINK_PROD_ACCOUNT_ID } from 'modules/desking/constants';

export const FinanceFieldSelector = () => {
  const { control, setValue } = useFormContext<FinanceProgramFormValues>();

  const dispatch = useDispatch();

  const financePrograms = useSelector(deskingSelectors.financePrograms);
  const financeProgramSelectOptions = useSelector(deskingSelectors.financeProgramSelectOptions);
  const isFinanceDetailsEditable = useSelector(deskingSelectors.selectFinanceDetailsEditableStatus);

  const handleSelectProgram = (programId: string) => {
    setValue('financeQuote.program', programId);
    const financeProgram = financePrograms?.[programId];

    if (financeProgram?.paymentOptionsConfiguration?.linkToLenderCreditApp) {
      setValue(
        'displaySettings.lenderProfileId',
        financeProgram.financeProgramToLenderProfiles?.[0]?.lenderProfileId ?? ''
      );
    }

    if (financeProgram?.accountId === (environmentName === 'dev' ? PAYLINK_DEV_ACCOUNT_ID : PAYLINK_PROD_ACCOUNT_ID)) {
      setValue('displaySettings.showFinanceProgramDescription', false);
    }

    setProgramDeps({
      dispatch,
      setValue,
      programConfig: financeProgram?.paymentOptionsConfiguration ?? null,
    });
  };

  return (
    <Controller
      control={control}
      name="financeQuote.program"
      render={({ field }) => (
        <FormInputSelect
          variant="standard"
          label="Select Program"
          options={financeProgramSelectOptions?.reverse() ?? []}
          disabled={!financeProgramSelectOptions?.length || !isFinanceDetailsEditable}
          {...field}
          onChange={handleSelectProgram}
        />
      )}
    />
  );
};
